import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Styled Components
import { Wrapper } from './AccountDetails.elements'

// Views
import { Container } from 'views/components'
import { App, Header, Sidebar, Content, PageWrapper } from 'views/layouts'
import { AccountDetails as AccountDetailsWrapper } from 'views/containers'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions

function AccountDetails() {
  return (
    <App>
      <Sidebar />
      <Header link="/directory" pageTitle="Accounts" />
      <Content>
        <PageWrapper>
          <Container>
            <Wrapper>
              <AccountDetailsWrapper />
            </Wrapper>
          </Container>
        </PageWrapper>
      </Content>
    </App>
  )
}

// Default Props
AccountDetails.defaultProps = {
  actions: {},
  ui: {},
  filters: {},
}

// Proptypes Validation
AccountDetails.propTypes = {
  actions: PropTypes.shape({
    setActiveModule: PropTypes.func,
    setShowHeaderLoader: PropTypes.func,
  }),
  ui: PropTypes.shape({}),
  filters: PropTypes.shape({}),
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountDetails)
